import { createAction, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';

const NAME_UI_STATE_MODULE = '[ui] Estado de la aplicación';
export const UI_STATE = createAction(NAME_UI_STATE_MODULE, props<{ message: string }>());
export const UI_STATE_OK = createAction(NAME_UI_STATE_MODULE, props<{ message: string }>());
export const UI_STATE_ERR = createAction(NAME_UI_STATE_MODULE, props<{ message: string; error: HttpErrorResponse }>());
